.header > div {
  max-width: var(--flix-page-max-width, var(--hcr-page-max-width));
}

.brand img {
  height: auto;
}

.widgets {
  justify-self: center;
  white-space: nowrap;
}
